import { render, staticRenderFns } from "./domain_lookup.vue?vue&type=template&id=85d83322&"
import script from "./domain_lookup.vue?vue&type=script&lang=js&"
export * from "./domain_lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports